import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import Loader from 'modules/common/components/Loader';
import { formatIsoStringDate } from 'utils/functions/time';
import membersStrings from 'modules/members/strings';
import { TransactionTypeMapping, transactionsTabsOptions } from 'constants/members';
import { status } from 'constants/general';

import {
  TableItem,
  PointsIcon,
  TypeCol,
  TypeIcon,
  GridWrapper,
  Row,
  HeaderItem,
  ColumnItem,
  Divider,
  LoaderWrapper,
} from './MemberTransactionsList.style';

const MemberTransactionsList = ({ queryObject }) => {
  const memberTransactionHeaderList = membersStrings.memberTransactions.gridHeaderList;

  const { memberTransactionsList } = useSelector(state => state.members);

  const transactionTabOption = transactionsTabsOptions.find(
    item => item.value === queryObject.transactionType,
  );

  return (
    <GridWrapper>
      <Row>
        {Object.keys(memberTransactionHeaderList).map(GridHeaderKey => (
          <HeaderItem key={GridHeaderKey}>{memberTransactionHeaderList[GridHeaderKey]}</HeaderItem>
        ))}
      </Row>
      {memberTransactionsList[transactionTabOption.key]?.details?.data?.length > 0 &&
        memberTransactionsList[transactionTabOption.key]?.details?.data?.map(transaction => {
          const transactionRow = {};

          transactionRow.id = transaction?.metadata?.transactionKey;
          transactionRow.date = formatIsoStringDate(transaction?.createdTime, true, 2);
          transactionRow.points = (
            <>
              <PointsIcon /> {transaction?.points}
            </>
          );

          const earned = transaction?.pointsStatus === 'Approved';
          transactionRow.type = (
            <TypeCol earned={earned}>
              <TypeIcon earned={earned} /> {TransactionTypeMapping[transaction?.pointsStatus]}
            </TypeCol>
          );

          transactionRow.catogory = transaction?.service?.serviceName;
          transactionRow.expiryDate =
            transaction?.expiryTime || transaction?.expiredPoints?.date
              ? formatIsoStringDate(
                  transaction?.expiryTime || transaction?.expiredPoints?.date,
                  false,
                  2,
                )
              : '—';

          transactionRow.expiredPoints = transaction?.expiredPoints?.points
            ? `${transaction?.expiredPoints?.points} points`
            : '—';

          return (
            <React.Fragment key={transactionRow.id}>
              <Divider />
              <Row>
                <ColumnItem>
                  <TableItem>{transactionRow.id}</TableItem>
                </ColumnItem>
                <ColumnItem>
                  <TableItem>{transactionRow.date}</TableItem>
                </ColumnItem>
                <ColumnItem>
                  <TableItem>{transactionRow.points}</TableItem>
                </ColumnItem>
                <ColumnItem>
                  <TableItem>{transactionRow.type}</TableItem>
                </ColumnItem>
                <ColumnItem>
                  <TableItem>{transactionRow.catogory}</TableItem>
                </ColumnItem>
                <ColumnItem>
                  <TableItem>{transactionRow.expiryDate}</TableItem>
                </ColumnItem>
                <ColumnItem>
                  <TableItem>{transactionRow.expiredPoints}</TableItem>
                </ColumnItem>
              </Row>
            </React.Fragment>
          );
        })}
      {memberTransactionsList[transactionTabOption.key]?.status === status.FETCHING && (
        <LoaderWrapper>
          <Loader width={40} height={40} thickness={4} />
        </LoaderWrapper>
      )}
    </GridWrapper>
  );
};

MemberTransactionsList.propTypes = {
  queryObject: PropTypes.shape({
    transactionType: PropTypes.oneOfType(PropTypes.number, PropTypes.string),
  }).isRequired,
};

export default MemberTransactionsList;
